import React from "react";

export default function Tooltip({ text, size = 18 }) {
  return (
    <span className="custom-tooltip-wrapper">
      <span
        className="material-icons info-icon"
        style={{ fontSize: size, height: size, lineHeight: `${size}px` }}
      >
        info
      </span>
      <span className="custom-tooltip-text">{text}</span>
    </span>
  );
}